import {TechnologyStack} from "../../ui/modules/home/tech-stack/store/tech-store";

export const  DisplayEnums = {
  // Language : {
  //   [Language.None] : "",
  //   [Language.Hy] : "Hy",
  //   [Language.Rus] : "Rus",
  //   [Language.En] : "En",
  // },
  TechStack : {
    [TechnologyStack.BackendArchitecture] : "Back-end & Architecture",
    [TechnologyStack.Frontend] : "Front-end",
    [TechnologyStack.MobileDevelopment] : "Mobile Development",
    [TechnologyStack.Databases] : "Databases",
    [TechnologyStack.CmsBaas] : "CMS & BaaS",
    [TechnologyStack.DevOpsObservability] : "DevOps & Observability",
    [TechnologyStack.QualityAssurance] : "Quality Assurance",
  }
}
